// extracted by mini-css-extract-plugin
export default {"section":"YsCY","section-head":"jvCS","sectionHead":"jvCS"};